/** 权限鉴权类型 */
export enum ZAuthType {
  /** 或权限（至少匹配一个） */
  'some' = 'some',
  /** 与权限（全部匹配） */
  'every' = 'every'
}

/** 页面权限 */
export enum ZAuthPagesRole {
  'noticeList' = 'noticeList',
  'projectList' = 'projectList',
  'roleManagement' = 'roleManagement'
}
/** 页面权限 */
export enum ZAuthButtonRole {
  'Save' = 'Save',
  'Accept' = 'Accept',
  'AssignTo' = 'AssignTo',
  'Resolved' = 'Resolved',
  'PRC' = 'Pause/Continue',
  'Export' = 'Export'
}
/** 角色权限类型，统一配置 */
export const ZAuthRole = {
  ...ZAuthPagesRole,
  ...ZAuthButtonRole
};
